// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
import { FIELD_TYPES } from "../../../../../../constants/template-field-type";
export default {
    linktext: {
        type: FIELD_TYPES.TEXT,
        label: "Linktext",
        translatable: true
    },
    text: {
        type: FIELD_TYPES.TEXT,
        label: "Text",
        translatable: true
    },
    title: {
        type: FIELD_TYPES.TEXT,
        label: "Title",
        translatable: true
    },
    link: {
        type: FIELD_TYPES.NESTED,
        label: "Link",
        fields: {
            href: {
                type: FIELD_TYPES.TEXT,
                label: "URL",
                translatable: true
            },
            target: {
                type: FIELD_TYPES.TEXT,
                label: "Target",
                translatable: false
            }
        }
    }
};
